// keyPath is used for accessing the dynamic configurable label or path from the LABEL_CONFIG file using getLabelPathFromLabelConfig util function
// Do not change anything in this file, if you are changing make sure you understand the impact of it.
// Mainly do not change the key part of the object as those are keys used everywhere.
export const DEFAULT_ROUTE_CONFIG = {
  modelInventory: {
    path: 'model',
    keyPath: 'MENUS.modelInventory',
  },
  inventory: {
    path: 'inventory',
    keyPath: 'MENUS.inventory',
  },
  archivedModels: {
    path: 'model/archived',
    keyPath: 'MENUS.modelInventory.subPaths.archivedModels',
  },
  archivedModelRequest: {
    path: 'assessments/archived',
    keyPath: 'MENUS.modelRequest.subPaths.archivedModelRequest',
  },
  archivedUseCase: {
    path: 'useCases/archived',
    keyPath: 'MENUS.useCase.subPaths.archivedUseCase',
  },
  createModel: {
    path: 'model/add-model',
    keyPath: 'MENUS.modelInventory.subPaths.createModel',
  },
  editModel: {
    path: 'model/:uniqueId',
    keyPath: 'MENUS.modelInventory.subPaths.editModel',
  },
  home: {
    keyPath: 'MENUS.home',
    path: 'home',
  },
  bulkUpload: {
    path: 'bulk-upload',
    keyPath: 'MENUS.bulkUpload',
  },
  bulkTransition: {
    path: 'bulk-transition',
    keyPath: 'MENUS.bulkTransition',
  },
  bulkUpdate: {
    path: 'bulk-update',
    keyPath: 'MENUS.bulkUpdate',
  },
  bulkDocumentUpload: {
    path: 'bulk-document',
    keyPath: 'MENUS.bulkDocumentUpload',
  },
  ModelAssociation: {
    path: 'model-artifact',
    keyPath: 'MENUS.ModelAssociation',
  },
  archivedArtifacts: {
    path: 'model-artifact/archived',
    keyPath: 'MENUS.ModelAssociation.subPaths.archivedArtifacts',
  },
  allArtifacts: {
    path: 'model-artifact/archived',
    keyPath: 'MENUS.ModelAssociation.subPaths.allArtifacts',
  },
  editModelAssociation: {
    path: 'model-artifact/:uniqueId',
    keyPath: 'MENUS.ModelAssociation.subPaths.editModelAssociation',
  },
  DocumentInventory: {
    path: 'documents',
    keyPath: 'MENUS.DocumentInventory',
  },
  workflow: {
    path: 'workflows',
    keyPath: 'MENUS.workflow',
  },
  editWorkflow: {
    path: 'workflows/edit-workflow',
    keyPath: 'MENUS.workflow.subPaths.editWorkflow',
  },
  generateWorkflow: {
    path: 'workflows/generate-workflow',
    keyPath: 'MENUS.workflow.subPaths.generateWorkflow',
  },
  templateList: {
    path: 'templates',
    keyPath: 'MENUS.templateList',
  },
  createTemplate: {
    path: 'templates/create-template',
    keyPath: 'MENUS.templateList.subPaths.createTemplate',
  },
  editTemplate: {
    path: 'templates/edit-template',
    keyPath: 'MENUS.templateList.subPaths.editTemplate',
  },
  globalAttributes: {
    path: 'global-attributes',
    keyPath: 'MENUS.globalAttributes',
  },
  attributeLibrary: {
    path: 'attributes',
    keyPath: 'MENUS.attributeLibrary',
  },
  constantAttributes: {
    path: 'constant-attributes',
    keyPath: 'MENUS.constantAttributes',
  },
  teamRoles: {
    path: 'team-roles',
    keyPath: 'MENUS.teamRoles',
  },
  rules: {
    path: 'rules',
    keyPath: 'MENUS.rules',
  },
  report: {
    path: 'report',
    keyPath: 'MENUS.report',
  },
  advanceReport: {
    path: 'advanceReport',
    keyPath: 'Menus.advanceReport',
  },
  viewAdvanceReport: {
    path: 'advanceReport/viewAdvanceReport',
    keyPath: 'Menus.advanceReport.subPaths.viewAdvanceReport',
  },
  reportCategory: {
    path: 'advanceReport/report-category',
    keyPath: 'MENUS.advanceReport.subPaths.reportCategory',
  },
  reportCanvas: {
    path: 'advanceReport/report-canvas',
    keyPath: 'MENUS.advanceReport.subPaths.reportCanvas',
  },
  userManagement: {
    path: 'user-management',
    keyPath: 'MENUS.userManagement',
  },
  appManagement: {
    path: 'app-management',
    keyPath: 'MENUS.appManagement',
  },
  emailManagement: {
    path: 'email-management',
    keyPath: 'MENUS.emailManagement',
  },
  documentInventory: {
    path: 'documents',
    keyPath: 'MENUS.documentInventory',
  },
  documentTemplate: {
    path: 'document-template',
    keyPath: 'MENUS.documentTemplate',
  },
  configuration: {
    path: 'configuration',
    keyPath: 'MENUS.Configuration',
  },
  editEntity: {
    path: 'configuration/entity/:uniqueId',
    keyPath: 'MENUS.Configuration.subPaths.editEntity',
  },
  bulkActions: {
    path: 'bulk-actions',
    keyPath: 'MENUS.bulkActions',
  },
  dynamicChart: {
    path: 'dynamic-chart',
    keyPath: 'MENUS.dynamicChart',
  },
  // dynamicToolbar: {
  //   path: 'dynamic-toolbar',
  //   keyPath: 'MENUS.dynamicToolbar',
  // },
  // createDynamicToolbar: {
  //   path: 'dynamic-toolbar/new',
  //   keyPath: 'MENUS.dynamicToolbar.subPaths.createDynamicToolbar',
  // },
  // editDynamicToolbar: {
  //   path: 'dynamic-toolbar/:uniqueId',
  //   keyPath: 'MENUS.dynamicToolbar.subPaths.editDynamicToolbar',
  // },

  automation: {
    path: 'automation',
    keyPath: 'MENUS.automation',
  },
  createAutomation: {
    path: 'automation/create-automation',
    keyPath: 'MENUS.automation.createAutomation',
  },
  updateAutomation: {
    path: 'automation/update-automation',
    keyPath: 'MENUS.automation.updateAutomation',
  },
  themeAndAppearance: {
    path: 'theme-appearance',
    keyPath: 'MENUS.themeAndAppearance',
  },
  notAuthorized: {
    path: 'not-authorized',
    keyPath: 'MENUS.notAuthorized',
  },
  modelRequest: {
    path: 'assessment',
    keyPath: 'MENUS.modelRequest',
  },
  editModelRequest: {
    path: 'assessment/:uniqueId',
    keyPath: 'MENUS.modelRequest.subPaths.editModelRequest',
  },
  accessRequest: {
    path: 'accessRequest',
    keyPath: 'MENUS.accessRequest',
  },
  editAccessRequest: {
    path: 'accessRequest/:uniqueId',
    keyPath: 'MENUS.accessRequest.subPaths.editAccessRequest',
  },
  useCase: {
    path: 'useCase',
    keyPath: 'MENUS.useCase',
  },
  editUseCase: {
    path: 'useCase/:uniqueId',
    keyPath: 'MENUS.useCase.subPaths.editUseCase',
  },
  query: {
    path: 'query',
    keyPath: 'MENUS.query',
  },
  editQuery: {
    path: 'query/:uniqueId',
    keyPath: 'MENUS.query.subPaths.editQuery',
  },
  emailTemplate: {
    path: 'email-template',
    keyPath: 'MENUS.emailTemplate',
  },
  createEmailTemplate: {
    path: 'email-template/create-email-template',
    keyPath: 'MENUS.emailTemplate.subPaths.createEmailTemplate',
  },
  editEmailTemplate: {
    path: 'email-template/:uniqueId',
    keyPath: 'MENUS.emailTemplate.subPaths.editEmailTemplate',
  },
  administrativeOptions: {
    path: 'administrative-options',
    keyPath: 'MENUS.administrativeOptions',
  },
  helpAndSupport: {
    path: 'help',
    keyPath: 'MENUS.helpAndSupport',
  },
  homepageSetup: {
    path: 'homepage-setup',
    keyPath: 'MENUS.homepageSetup',
  },
  systemId: {
    path: 'system-id',
    keyPath: 'MENUS.systemId',
  },
  idViaTemplate: {
    path: 'id-via-template',
    keyPath: 'MENUS.idViaTemplate',
  },
  entityManagement: {
    path: 'entity-management',
    keyPath: 'MENUS.entityManagement',
  },
  logs: {
    path: 'logs',
    keyPath: 'MENUS.logs',
  },
  configurationLogs: {
    path: 'system-logs',
    keyPath: 'MENUS.logs.subPaths.configurationLogs',
  },
};
